import type { FC } from 'react';
import { useRef } from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

interface TextSkeletonProps {
  lineHeight?: number;
  lineLimiter?: number;
}

const TextSkeleton: FC<TextSkeletonProps> = ({
  lineHeight = 30,
  lineLimiter = 2.2,
}) => {
  const lineCount = Math.round(window.innerHeight / (lineHeight * lineLimiter));
  const lastWidth = useRef(100);

  const getWidth = () => {
    const generateNewWidth = Math.floor(Math.random() * 2);
    if (generateNewWidth) {
      // Calculation: width = floor(randomNumber * (maxWidth - minWidth) + minWidth)
      lastWidth.current = Math.floor(Math.random() * (100 - 33) + 33);
    }
    return lastWidth.current;
  };

  return (
    <Stack
      direction="column"
      spacing={1.5}
      sx={{ width: '100%', px: 1, py: Math.floor(lineHeight / 15) }}
    >
      {new Array(lineCount).fill(0).map((_, i) => {
        const isHeadline = !(i % 10);
        return (
          <Box key={i} sx={{ width: `${getWidth()}%`, pb: isHeadline ? 2 : 0 }}>
            <Skeleton
              variant="text"
              height={isHeadline ? lineHeight * 2 : lineHeight}
            />
          </Box>
        );
      })}
    </Stack>
  );
};

export default TextSkeleton;
